<div class="sec-title">
    <h1>Factures</h1>
</div>
  <ul class="editing-list list-group">
    <li class="list-group-item list-group-header">
      <div class="card">
        <div class="row">
          <div class="col-lg-6 col-md-12">
          </div>
          <div class="col-lg-3 col-md-4 mt-4">
            <a class="btn btn-action btn-filter me-3  mb-3" [ngClass]="{'selected_filter': filter=='all'}" (click)="changeInvoiceFilter('all')" role="button"> Toutes</a> <a class="btn btn-action btn-filter mb-3" [ngClass]="{'selected_filter': filter=='rec'}" (click)="changeInvoiceFilter('rec')" role="button"> Comptes à recevoir</a>
          </div>
          <div class="col-lg-3 col-md-12 align-text-bottom header-action-btn">

              <form [formGroup]="searchInvoiceForm" (ngSubmit)="onSubmit(searchInvoiceForm.value)" novalidate>
                <div class="form-group input-group mb-3">
                  <label for="search_invoice" class="visually-hidden">Recherche</label>
                  <input type="text" class="form-control" name="search_invoice" id="search_invoice" formControlName="search_invoice" placeholder="Recherche...">
                  <div class="input-group-append">
                    <button type="submit" class="input-group-text right-action-btn">
                      <i title="Recherche" class="bi bi-search"></i>
                    </button>
                  </div>
                </div>
    
                <button type="submit" class="btn btn-primary visually-hidden">Rechercher</button>
              </form>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-6 col-md-11">
                  <div class="row">
                    <div class="col-md-6 col-lg-1">Facture #</div>
                    <div class="col-md-6 col-lg-2">Date</div>
                    <div class="col-md-6 col-lg-2">Contrat</div>
                    <div class="col-md-6 col-lg-3">Client</div>
                    <div class="col-md-6 col-lg-3">Adresse</div>
                  </div>
                </div>
                <div class="col-md-1 d-flex justify-content-end action-icons">
                  <div>Modifier</div>
                </div>
            </div>
        </div>
      </div>
    </li>
    <li class="list-group-item" *ngIf="total === 0 && isSearch == true">
      <div class="card">
        <div class="card-body">
          <div class="row mt-3 ms-3 mb-3 strong">
                {{no_results_message}}
          </div>
        </div>
      </div>
    </li>
    <li *ngIf="diplay_loading != '' && isSearch == false; else Results" class="list-group-item">
        <div class="card">
          <div class="card-body">
            <div class="mt-3 ms-3 mb-3 strong">
              {{ diplay_loading }}
              <span class="spinner-grow spinner-grow-sm ms-2" style="width: 0.5rem; height: 0.5rem;" role="status" aria-hidden="true"></span>
              <span class="spinner-grow spinner-grow-sm ms-2" style="width: 0.5rem; height: 0.5rem;" role="status" aria-hidden="true"></span>
              <span class="spinner-grow spinner-grow-sm ms-2" style="width: 0.5rem; height: 0.5rem;" role="status" aria-hidden="true"></span>  
            </div>
          </div>
        </div>
    </li>
    <ng-template #Results>
    <li class="list-group-item" *ngFor="let invoice of invoiceInfo | paginate: { itemsPerPage: limits, currentPage: p+1, totalItems: total}; let i = index">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-11">
              <div class="row">
                <div class="col-md-1">
                  <p class="card-title">Facture #{{invoice.invoice_no}}</p>
                </div>
                <div class="col-md-2">
                  <p class="card-title card-title-main">{{invoice.created | date}}</p>
                </div>
                <div class="col-md-2">
                  <p class="card-title card-title-main"> <a href="/soumission/{{invoice.submission.submission_id}}/editer"><i class="bi bi-link"></i>{{invoice.submission.submission_no}} </a></p>
                </div>
                <div class="col-md-3">
                  <p class="card-title card-title-main"><a href="/client/{{invoice.client.client_id}}/editer"><i class="bi bi bi-person"></i>{{invoice.client.client_fname}} {{invoice.client.client_lname}}</a></p>
                </div>
                <div class="col-md-3">
                  <div class="card-subtitle mb-2 text-muted">
                    <address> 
                      {{invoice.submission.address}}, {{invoice.submission.city}}, 
                      {{invoice.submission.province}} {{invoice.submission.address2}} 
                      {{invoice.submission.country}}
                    </address>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-1 d-flex justify-content-end action-icons">
              <a routerLink="/client/{{invoice.client.client_id}}/editer" class="card-link">
                <button type="button" class="btn btn-outline-secondary left-action-btn">
                  <i class="bi bi bi-person" title="Voir le client"></i>
                </button>
              </a>
              <a (click)="invoicePrint(invoice.invoice_id, invoice.invoice_no)" class="card-link">
                <button type="button" class="btn btn-outline-secondary middle-action-btn">
                  <i class="bi bi-printer-fill"  title="imprimer"></i>
                </button>
              </a>
              <a routerLink="/facture/{{invoice.invoice_id}}/editer" class="card-link">
                <button type="button" class="btn btn-outline-secondary right-action-btn">
                  <i class="bi bi-pencil-square"  title="Modifier la facture"></i>
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </li>
    </ng-template>
  </ul>
  <pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>
  <hr/>
  <div id="print-section"></div>